import { useQuery } from "@tanstack/react-query";
import { checkCoverage } from "../services/teleconsultationService";

interface CoverageResponse {
  success: boolean;
  data: {
    is_covered: boolean;
    is_free: boolean;
    coverage_percentage: number;
    remaining_benefit: number;
    max_benefit?: number;
    error?: boolean;
    is_dokter_umum: boolean;
  };
}

export const useCoverage = (authToken?: string | null) => {
  return useQuery<CoverageResponse>({
    queryKey: ["coverage-info"],
    queryFn: async () => {
      return await checkCoverage(authToken as string);
    },
    enabled: !!authToken,
    staleTime: 60000,
    refetchOnWindowFocus: false,
  });
};